import React from "react";
import { Link } from "react-router-dom";

import bg1 from '../../assets/images/bg/bg-crypto.jpg'
import crypto from '../../assets/images/crypto.png'
import cryptoCell from '../../assets/images/crypto-cell.png'

import Navbar from "../../components/navbar";
import CompanyLogo from "../../components/companyLogo";
import FooterTop from "../../components/footerTop";
import Footer from "../../components/footer";
import ScrollTop from "../../components/scrollTop";

import { AiOutlineExclamationCircle, FiArrowDown, FaApple, PiGooglePlayLogo, MdOutlineCheckCircle, FaFacebookSquare, SlSocialGoogle } from '../../assets/icons/icons'

import { cryptoRoadMap, cryptoWorkData } from "../../data/data";

import TinySlider from "tiny-slider-react";
import 'tiny-slider/dist/tiny-slider.css';

export default function IndexCrypto(){
    let settings = {
        container: '.slider-range-four',
        items: 4,
        controls: false,
        mouseDrag: true,
        loop: true,
        rewind: true,
        autoplay: true,
        autoplayButtonOutput: false,
        autoplayTimeout: 3000,
        navPosition: "bottom",
        speed: 400,
        gutter: 24,
        responsive: {
            992: {
                items: 4
            },

            767: {
                items: 2
            },
            

            320: {
                items: 1
            },
        },
      };
    return(
        <>
        <Navbar navLight={true}/>

        <section className="bg-home d-flex align-items-center" style={{backgroundImage:`url(${bg1})`, backgroundPosition:'center'}}>
            <div className="container">
                <div className="row mt-5">
                    <div className="col-12">
                        <div className="heading-title">
                            <h4 className="display-3 text-white title-dark mb-3 fw-bold">Profitability <br/> on the Rise</h4>
                            <p className="text-white-50 para-desc mb-0">Explore and learn more about everything from machine learning and global payments to  scaling your team.</p>
                        
                            <div className="mt-4 pt-2 align-items-center">
                                <Link to="#" className="btn btn-lg btn-primary">Start Trading</Link>
                                <p className="text-white-50 mb-0 mt-3 d-flex align-items-center"><AiOutlineExclamationCircle className="me-2"/> It's free to use</p>
                            </div>
                        </div>
                    </div>
                    <div className="home-shape-arrow">
                        <Link to="#roadmap" className="btn btn-icon btn-pills btn-lg btn-footer scroll-down"><FiArrowDown className="icons"/></Link>
                    </div>
                </div>
            </div>
        </section>

        <section className="section">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-12">
                        <div className="section-title mb-4 pb-2 text-center">
                            <h4 className="title mb-4">Smooth Experience on Any Device</h4>
                            <p className="text-muted mx-auto para-desc mb-0">Explore and learn more about everything from machine learning and global payments to  scaling your team.</p>
                        </div>
                    </div>
                </div>

                <div className="row align-items-center">
                    <div className="col-lg-8 col-md-7 mt-4 pt-2">
                        <img src={crypto} className="img-fluid" alt=""/>
                    </div>

                    <div className="col-lg-4 col-md-5 mt-4 pt-2">
                        <div className="section-title">
                            <h4>The custom-built platform has been adapted for any device you may choose and switching is 100% seamless.</h4>

                            <div className="d-flex align-items-center rounded-md bg-light mt-4 shadow p-4">
                                <h2 className="display-4 fw-bold mb-0">4.9</h2>
                                <div className="flex-1 ms-3">
                                    <ul className="list-unstyled mb-0 h5">
                                        <li className="list-inline-item"><i className="mdi mdi-star text-warning"></i></li>
                                        <li className="list-inline-item"><i className="mdi mdi-star text-warning"></i></li>
                                        <li className="list-inline-item"><i className="mdi mdi-star text-warning"></i></li>
                                        <li className="list-inline-item"><i className="mdi mdi-star text-warning"></i></li>
                                        <li className="list-inline-item"><i className="mdi mdi-star text-warning"></i></li>
                                    </ul>

                                    <h6 className="mb-0">Customer Rating</h6>
                                </div>
                            </div>

                            <div className="mt-4 text-center">
                                <Link to="#" className="btn btn-primary m-1"><FaApple /> App Store</Link>
                                <Link to="#" className="btn btn-soft-primary m-1"><PiGooglePlayLogo /> Play Store</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="container mt-100 mt-60">
                <div className="row align-items-center">
                    <div className="col-md-5 order-1 order-md-2 mt-4 pt-2">
                        <img src={cryptoCell} className="img-fluid" alt=""/>
                    </div>

                    <div className="col-md-7 order-2 order-md-1 mt-4 pt-2">
                        <div className="section-title">
                            <h2 className="mb-4">Take control of your <br/> credit and identity.</h2>
                            <p className="text-muted para-desc">Explore and learn more about everything from machine learning and global payments to  scaling your team.</p>
                            <ul className="list-unstyled text-muted">
                                <li className="mb-0 ms-0"><span className="text-primary h5 me-2"><MdOutlineCheckCircle className="align-middle"/></span>Digital Marketing Solutions for Tomorrow</li>
                                <li className="mb-0 ms-0"><span className="text-primary h5 me-2"><MdOutlineCheckCircle className="align-middle"/></span>Our Talented & Experienced Marketing Agency</li>
                                <li className="mb-0 ms-0"><span className="text-primary h5 me-2"><MdOutlineCheckCircle className="align-middle"/></span>Create your own skin to match your brand</li>
                            </ul>
                            <div className="mt-4">
                                <Link to="#" className="btn btn-primary">Learn more</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section className="section bg-light" id="roadmap">
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <div className="section-title text-center mb-4 pb-2">
                            <h4 className="title mb-4">Success Roadmap</h4>
                            <p className="text-muted mx-auto para-desc mb-0">Explore and learn more about everything from machine learning and global payments to  scaling your team.</p>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-12 mt-4 pt-2">
                        <div className="col-md-12">
                            <div className="slider-range-four tiny-timeline">
                                <TinySlider settings={settings}> 
                                    {cryptoRoadMap.map((item, index) =>{
                                        let Icon = item.icon
                                        return(
                                            <div className="tiny-slide text-center" key={index}>
                                                <div className="card border-0 p-4 item-box shadow rounded">
                                                    <Icon className="h4 text-primary w-100"/>
                                                    <p className="text-muted mb-0">{item.month}</p>
                                                    <h5 className="mb-0 mt-1">{item.title}</h5>
                                                </div>
                                            </div>
                                        )
                                    })}
                                </TinySlider>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section className="section">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-12">
                        <div className="section-title text-center mb-4 pb-2">
                            <h4 className="title mb-4">A Platform that Works for You</h4>
                            <p className="text-muted mx-auto para-desc mb-0">Explore and learn more about everything from machine learning and global payments to  scaling your team.</p>
                        </div>
                    </div>
                </div>

                <div className="row">
                    {cryptoWorkData.map((item,index) =>{
                        let Icon = item.icon
                        return(
                        <div className="col-lg-4 col-md-6 mt-4 pt-2" key={index}>
                            <div className="card features feature-primary core-feature shadow rounded p-4 text-center border-0">
                                <div className="icon text-center rounded-circle mx-auto">
                                    <h3 className="mb-0"><Icon/></h3>
                                </div>
                                <div className="card-body p-0 mt-4">
                                    <Link to="#" className="title text-dark h5">{item.title}</Link>
                                    <p className="text-muted mt-2 mb-0">{item.desc}</p>
                                </div>
                            </div>
                        </div>
                        )
                    })}
                </div>
            </div>

            <div className="container mt-5">
                <CompanyLogo/>
            </div>

            <div className="container mt-100 mt-60">
                <div className="row justify-content-center">
                    <div className="col-12">
                        <div className="section-title text-center mb-4 pb-2">
                            <h4 className="title mb-4">Open a Free Account Right Now</h4>
                            <p className="text-muted mx-auto para-desc mb-0">Explore and learn more about everything from machine learning and global payments to  scaling your team.</p>
                        </div>
                    </div>
                </div>

                <div className="row justify-content-center">
                    <div className="col-lg-10">
                        <div className="row align-items-center">
                            <div className="col-lg-6 col-md-6 mt-4 pt-2">
                                <img src={cryptoCell} className="img-fluid" alt=""/>
                            </div>
        
                            <div className="col-lg-6 col-md-6 mt-4 pt-2">
                                <form className="ms-lg-4">
                                    <div className="row">
                                        <div className="col-lg-12">
                                            <div className="mb-3 position-relative">
                                                <label className="form-label">Name : <span className="text-danger">*</span></label>
                                                <input type="text" className="form-control" placeholder="Name" name="name" required=""/>
                                            </div>
                                        </div>
        
                                        <div className="col-lg-12">
                                            <div className="mb-3 position-relative">
                                                <label className="form-label">Email : <span className="text-danger">*</span></label>
                                                <input type="email" className="form-control" placeholder="Email" name="email" required=""/>
                                            </div>
                                        </div>
        
                                        <div className="col-lg-12">
                                            <div className="mb-3 position-relative">
                                                <label className="form-label">Password : <span className="text-danger">*</span></label>
                                                <input type="password" className="form-control" placeholder="Password" required=""/>
                                            </div>
                                        </div>

                                        <div className="col-md-12">
                                            <div className="mb-3">
                                                <div className="form-check">
                                                    <input className="form-check-input" type="checkbox" value="" id="flexCheckDefault"/>
                                                    <label className="form-check-label" htmlFor="flexCheckDefault">I Accept <Link to="#" className="text-primary">Terms And Condition</Link></label>
                                                </div>
                                            </div>
                                        </div>
        
                                        <div className="col-lg-12 mt-2 mb-0">
                                            <div className="d-grid">
                                                <button className="btn btn-primary">Try it out now</button>
                                            </div>
                                        </div>

                                        <div className="col-lg-12 mt-4 text-center">
                                            <h6>Or Signup With</h6>
                                        </div>
                                        
                                        <div className="col-6 mt-3">
                                            <div className="d-grid">
                                                <Link to="#" className="btn btn-soft-primary"><FaFacebookSquare /> Facebook</Link>
                                            </div>
                                        </div>
                                        
                                        <div className="col-6 mt-3">
                                            <div className="d-grid">
                                                <Link to="#" className="btn btn-soft-primary"><SlSocialGoogle /> Google</Link>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <FooterTop/>
        <Footer/>
        <ScrollTop/>
        </>
    )
}